import * as React from 'react'

function SvgMedicalhistory2(props, svgRef) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="files-medical"
      className="medical_history2_svg__svg-inline--fa medical_history2_svg__fa-files-medical medical_history2_svg__fa-w-14"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      ref={svgRef}
      {...props}
    >
      <path
        fill="currentColor"
        d="M96 392V96H24a24 24 0 00-24 24v368a24 24 0 0024 24h272a24 24 0 0024-24v-40H152a56.06 56.06 0 01-56-56zm224-288V0H152a24 24 0 00-24 24v368a24 24 0 0024 24h272a24 24 0 0024-24V128H344a24.07 24.07 0 01-24-24zm64 128v48a8 8 0 01-8 8h-56v56a8 8 0 01-8 8h-48a8 8 0 01-8-8v-56h-56a8 8 0 01-8-8v-48a8 8 0 018-8h56v-56a8 8 0 018-8h48a8 8 0 018 8v56h56a8 8 0 018 8zm57-159L375 7a24 24 0 00-17-7h-6v96h96v-6.06A24 24 0 00441 73z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgMedicalhistory2)
export default ForwardRef
